<template>
  <list-items :suppress="0" />
</template>

<script>
import ListItems from '@/modules/audiences/pages/BaseListItems'
export default {
  components: { ListItems }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/UserListItems.vue